import { gql } from '@apollo/client';

export const GET_CLIENTS_FRAGMENT = gql`
  fragment Clients on Query {
    clients {
      id
      name
      accounts {
        id
        codeTiers
      }
      users {
        email
        isActive
      }
    }
  }
`;
